import {
  Box,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { IBooking } from '../../utils/entities/interface';
import { Person, Visibility } from '@mui/icons-material';
import { getBookingStatusLabel } from '../../pages/Booking/actions/Assignbooking';
import {
  capitalizeWords,
  formatDate,
  formatPhoneNumber,
} from '../../utils/helper';
import { Link } from 'react-router-dom';

export const CustomerBookingDetails = ({
  booking,
  type,
}: {
  booking: IBooking | null;
  type?: 'REGULAR' | 'CUSTOMERHISTORY' | 'TECHNICIANHISTORY' | 'VIEWDETAIL';
}) => {
  return (
    <>
      {/* Booking Detail Card */}
      <Box
        sx={{
          backgroundColor: 'transparent',
          color: '#fff',
          borderRadius: 2,
        }}
      >
        <CardHeader
          title={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {type === 'VIEWDETAIL' ? (
                  <>
                    <Typography variant="h6">Booking Detail</Typography>
                    <svg
                      onClick={() => {
                        window.open(`/bookings/edit/${booking?._id}`, '_self');
                      }}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V17"
                        stroke="#7B1FA2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16 4.99998L19 7.99998M20.385 6.58499C20.7788 6.19114 21.0001 5.65697 21.0001 5.09998C21.0001 4.543 20.7788 4.00883 20.385 3.61498C19.9912 3.22114 19.457 2.99988 18.9 2.99988C18.343 2.99988 17.8088 3.22114 17.415 3.61498L9 12V15H12L20.385 6.58499Z"
                        stroke="#7B1FA2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </>
                ) : (
                  <>
                    <Typography variant="h6">Customer Detail</Typography>
                    <Person />
                  </>
                )}
              </Box>
              <Typography variant="body1">
                Status:{' '}
                <span
                  style={{
                    color:
                      booking?.status === 'CANCELLED' ? '#7B1FA2' : '#0BE600',
                  }}
                >
                  {booking?.status && getBookingStatusLabel(booking?.status)}
                </span>
              </Typography>
            </Box>
          }
        />
        <Divider sx={{ borderColor: '#565656' }} />
        <CardContent sx={{ backgroundColor: '#232323', p: 3 }}>
          <Grid
            container
            spacing={1}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              //   border: '2px solid red',
            }}
          >
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Full Name
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body2"
                component={Link} // Makes it behave like a link
                to={`/customers/${booking?.user._id}`} // Navigate to technician details
                sx={{
                  color: '#0BE600',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {capitalizeWords(booking?.user.name ?? '')}
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Contact Number
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body2"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {formatPhoneNumber(booking?.user.phoneNumber ?? '')}
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Customer Type
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body2"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {booking?.user?.type
                  ? capitalizeWords(booking?.user?.type).replace('_', ' ')
                  : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Booking Date
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body2"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {formatDate(booking?.date)}
              </Typography>
            </Grid>

            <Grid item xs={2} sx={{ color: 'gray' }}>
              Booking Slot
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body2"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {(booking?.slot &&
                  capitalizeWords(booking?.slot.replace('_', ' '))) ||
                  'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Service Address
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body2"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {booking?.addressDetails?.[0]?.saveAs
                  ? capitalizeWords(booking.addressDetails[0].saveAs)
                  : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Address
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
                {[
                  booking?.addressDetails[0]?.house,
                  booking?.addressDetails[0]?.street,
                  booking?.addressDetails[0]?.landmark,
                  booking?.addressDetails[0]?.city,
                  booking?.addressDetails[0]?.state,
                  booking?.addressDetails[0]?.zipcode,
                ]
                  .filter(Boolean) // Removes undefined/null values
                  .join(', ')}
              </Typography>
            </Grid>
            {booking?.technician?._id && (
              <>
                <Grid item xs={2} sx={{ color: 'gray' }}>
                  Assign Technician
                </Grid>
                <Grid item xs={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
                      {capitalizeWords(booking.technician.name ?? '')}
                    </Typography>
                    <IconButton
                      component={Link}
                      to={`/technicians/${booking.technician._id}`}
                      size="small"
                      sx={{ color: '#7B1FA2', p: 0.25 }}
                      aria-label="View technician profile"
                    >
                      <Visibility fontSize="small" />
                    </IconButton>
                  </Box>
                </Grid>
              </>
            )}
            {booking?.status === 'CANCELLED' && (
              <>
                <Grid item xs={2} sx={{ color: 'gray' }}>
                  Cancelled Reason
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
                    {booking?.cancelReason || 'N/A'}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
        <Divider sx={{ borderColor: '#565656' }} />
      </Box>
    </>
  );
};
